<template>
  <dv-full-screen-container class="box-content" ref="contentRef">
    <dv-loading v-if="Loading">Loading...</dv-loading>
    <div class="app-container">
      <div class="n-header">
        <p class="n-name">{{ user && user.areaName }}共享单车管理服务平台</p>
        <span class="n-time">{{
            nTime | dateFormat("yyyy-MM-dd hh:mm:ss")
          }}</span>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
             <i class="iconfont icon-touxiang" style="font-size: 32px;color: #00DADA;"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1" v-if="user">
              <i class="iconfont icon-gerentouxiang_o" style="font-size: 25px;color: #00dada;"></i>
              <div style="float: right;margin-top: 2px;margin-right: 15px;">{{ user.name }}</div>
            </el-dropdown-item>
            <el-dropdown-item command="2">
              <i class="iconfont icon-ico_xiugaimima" style="font-size: 25px;color: #00DADA;"></i>
              修改密码
            </el-dropdown-item>
            <el-dropdown-item command="3">
              <i class="iconfont icon-tuichudenglu" style="font-size: 25px;color: #00DADA;"></i>
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!--多企业品牌-->
       <div class="n-body" v-if="companyBrandList.length>1||companyBrandList.length===0">
        <div class="total card">
          <div class="card-title">
            <span @click="go('operation')">总量监测</span>
            <el-radio-group size="mini" class="btn-group">
              <el-radio
                label="bikeMonitor"
                border
                @click.native.prevent="changeAbnormal('bikeMonitor')">备案监测</el-radio>
              <el-radio
                label="notupload"
                border
                @click.native.prevent="notupload">未传数据车</el-radio>
              <el-radio label="sumchart" border @click.native.prevent="sumchart">总量曲线</el-radio>
              <div :class="{ no_active: ispie }" @click="ispie = true">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div :class="{ no_active: !ispie }" @click="ispie = false">
                <i class="el-icon-arrow-right"></i>
              </div>
            </el-radio-group>
          </div>
          <TotalRing
            v-if="companyBrandList.length>1||companyBrandList.length===0"
             ref="totalRingChart"
             v-show="checkUserAuth(64, 60)"
             :selfAreaId="selfAreaId"
             :statistical="statistical"
             @showModel="onShowDialog"
             @filterBike="filterBike"
             :ispie="ispie"
          />
        </div>
        <mapbox
          class="map"
          ref="mapbox"
          :selfAreaId="selfAreaId"
          :abnormalType="abnormalType"
          :statistical.sync="statistical"
          :mapsite.sync="mapsite"
          :siteMessage.sync="siteMessage"
        ></mapbox>
        <div class="card" v-if="companyBrandList.length>1||companyBrandList.length===0">
<!--          style="height: calc(35vh - 5px);"-->
          <div class="card-title">
            <span @click="go('operation')">运营统计</span>
          </div>
          <statistics :selfAreaId="selfAreaId" :isAggregation="isAggregation" :brandList="companyBrandList"></statistics>
        </div>
        <div class="nav">
          <img src="../../assets/image/发光.png" alt="" class="top-img" />
          <img src="../../assets/image/底部.png" alt="" class="footer-img" />
          <div class="nav-item active" @click="refresh">
            <img src="../../assets/image/menu/1.png" class="small" />
            <img src="../../assets/image/menu/11.png" class="big" />
            <div>日常值守</div>
          </div>
          <div class="nav-item" @click="go('operation')">
            <img src="../../assets/image/menu/2.png" class="small" />
            <img src="../../assets/image/menu/22.png" class="big" />
            <div>运营统计</div>
          </div>
          <div class="nav-item" @click="go('miBicycle')">
            <img src="../../assets/image/menu/4.png" class="small" />
            <img src="../../assets/image/menu/44.png" class="big" />
            <div>觅单车管理</div>
          </div>
          <div class="nav-item" @click="go('ratingEvaluation')">
            <img src="../../assets/image/menu/8.png" class="small" />
            <img src="../../assets/image/menu/88.png" class="big" />
            <div>评分评价</div>
          </div>
          <div class="nav-item" @click="go('deviceManagement')">
            <img src="../../assets/image/menu/3.png" class="small" />
            <img src="../../assets/image/menu/33.png" class="big" />
            <div>站点管理</div>
          </div>
          <div class="nav-item" @click="go('companyManagement')">
            <img src="../../assets/image/menu/5.png" class="small" />
            <img src="../../assets/image/menu/55.png" class="big" />
            <div>企业管理</div>
          </div>
          <div class="nav-item" @click="go('inforManagement')">
            <img src="../../assets/image/menu/6.png" class="small" />
            <img src="../../assets/image/menu/66.png" class="big" />
            <div>资料管理</div>
          </div>
          <div class="nav-item" @click="go('regionalSettings')">
            <img src="../../assets/image/menu/7.png" class="small" />
            <img src="../../assets/image/menu/77.png" class="big" />
            <div>系统设置</div>
          </div>
        </div>
        <div class="right">
          <div class="card">
            <div class="card-title">
              <span @click="go('warn')">异常告警</span>
              <el-radio-group
                v-model="abnormalType"
                size="mini"
                class="btn-group">
                <el-radio
                  :label="1"
                  border
                  @click.native.prevent="changeAbnormal(1)">站外还车</el-radio>
                <el-radio
                  :label="7"
                  border
                  @click.native.prevent="changeAbnormal(7)">非法车辆</el-radio>
                <el-radio
                  :label="13"
                  border
                  @click.native.prevent="changeAbnormal(13)">站外投车</el-radio>
                <el-radio
                  :label="14"
                  border
                  @click.native.prevent="changeAbnormal(14)">超区停放</el-radio>
                <el-radio
                  label="recycleSwitch"
                  border
                  @click.native.prevent="changeAbnormal('recycleSwitch')">回收站点</el-radio>
              </el-radio-group>
            </div>
            <warnTable
              :abnormalType="abnormalType"
              :selfAreaId="selfAreaId"
            ></warnTable>
          </div>
          <div class="card">
            <div class="card-title">
              <span class="nopoint">调度指引</span>
              <el-button
                v-if="aggregation === 0"
                @click="onShowDialog({ type: 3 })"
                plain
                size="small"
                class="glow-button"
              >满桩值设置
              </el-button>
              <el-button
                v-show="checkUserAuth(64, 59)"
                @click="onShowDialog({ type: 6, selfAreaId: selfAreaId })"
                plain
                size="small"
                class="glow-button"
              >
                站点排名
              </el-button>

            </div>
            <dispatchGuide
              :selfAreaId="selfAreaId"
              @showModel="onShowDialog"
              @filterSite="filterSite"
            />
          </div>
          <div class="card">
            <div class="card-title">
              <span class="nopoint">待处理事件</span>
            </div>
            <div class="toDoList">
              <div class="item" @click="go('miBicycle', { site: true })">
                站点申请<span>{{
                  toDo && toDo.siteApplyPend ? toDo.siteApplyPend : 0
                }}</span>
              </div>
              <div class="item" @click="go('miBicycle', { role: 27 })">
                站点角色申请
                <span>{{
                    toDo && toDo.maintainPend ? toDo.maintainPend : 0
                  }}</span>
              </div>
              <div
                class="item"
                @click="go('deviceManagement', { equipmentPower: '0-10' })"
              >
                站点电量低于10%<span>{{
                  toDo && toDo.siteLowPowerPend ? toDo.siteLowPowerPend : 0
                }}</span>
              </div>
              <div class="item" @click="go('miBicycle', { role: 5 })">
                违规举报
                <span>{{ toDo && toDo.accusePend ? toDo.accusePend : 0 }}</span>
              </div>
              <div
                class="item"
                @click="go('regionalSettings', { audit: true })"
              >
                平台账号申请<span>{{
                  toDo && toDo.userPend ? toDo.userPend : 0
                }}</span>
              </div>
              <div class="item" @click="go('miBicycle', { role: 31 })">
                运维员申请
                <span>{{
                    toDo && toDo.dispatchPend ? toDo.dispatchPend : 0
                  }}</span>
              </div>
              <div class="item" @click="go('miBicycle', { role: 32 })">
                监管员申请
                <span>{{
                    toDo && toDo.supervisePend ? toDo.supervisePend : 0
                  }}</span>
              </div>
              <div class="item" @click="go('miBicycle', { role: 34,clockWarn: true, dateFormat: clockDay,clockRole: 1})">
                运维员预警
                <span>{{ toDo && toDo.dispatchWarnPend ? toDo.dispatchWarnPend : 0 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--单企业品牌-->
      <div class="n_body_two" v-if="companyBrandList.length===1">
        <div class="totalTwo card" :style="{'height': heightControlTwo}">
          <div class="card-title">
            <span @click="go('operation')">总量监测</span>
            <el-radio-group size="mini" class="btn-group">
              <el-radio
                label="bikeMonitor"
                border
                @click.native.prevent="changeAbnormal('bikeMonitor')">备案监测</el-radio>
              <el-radio
                label="notupload"
                border
                @click.native.prevent="notupload">未传数据车</el-radio>
              <el-radio label="sumchart" border @click.native.prevent="sumchart">总量曲线</el-radio>
              <div :class="{ no_active: ispie }" @click="ispie = true">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div :class="{ no_active: !ispie }" @click="ispie = false">
                <i class="el-icon-arrow-right"></i>
              </div>
            </el-radio-group>
          </div>
          <singleTotalRing v-if="companyBrandList.length===1"
                           ref="singleTotalRingChart"
                           v-show="checkUserAuth(64, 60)"
                           :selfAreaId="selfAreaId"
                           :statistical="statistical"
                           :brandList="companyBrandList"
                           @showModel="onShowDialog"
                           @filterBike="filterBike"
                           :ispie="ispie"
          ></singleTotalRing>
        </div>
        <mapbox
          class="mapTwo"
          ref="mapbox"
          :selfAreaId="selfAreaId"
          :abnormalType="abnormalType"
          :statistical.sync="statistical"
          :mapsite.sync="mapsite"
          :siteMessage.sync="siteMessage"
        ></mapbox>
        <div class="card" style="height: calc(35vh - 5px);" v-if="companyBrandList.length===1">
          <div class="card-title">
            <span @click="go('operation')">运营统计</span>
          </div>
          <statistics :selfAreaId="selfAreaId" :isAggregation="isAggregation" :brandList="companyBrandList" />
        </div>
        <siteRanking
          class="menuTwo"
          :siteRankType="6"
          :selfAreaId="selfAreaId"
          @singleRankMethod="onShowDialog({ type: 6, selfAreaId: selfAreaId })"
        ></siteRanking>
        <div class="navTwo">
          <img src="../../assets/image/发光.png" alt="" class="top-img" />
          <img src="../../assets/image/底部.png" alt="" class="footer-img" />
          <div class="nav-item active" @click="refresh">
            <img src="../../assets/image/menu/1.png" class="small" />
            <img src="../../assets/image/menu/11.png" class="big" />
            <div>日常值守</div>
          </div>
          <div class="nav-item" @click="go('operation')">
            <img src="../../assets/image/menu/2.png" class="small" />
            <img src="../../assets/image/menu/22.png" class="big" />
            <div>运营统计</div>
          </div>
          <div class="nav-item" @click="go('miBicycle')">
            <img src="../../assets/image/menu/4.png" class="small" />
            <img src="../../assets/image/menu/44.png" class="big" />
            <div>觅单车管理</div>
          </div>
          <div class="nav-item" @click="go('ratingEvaluation')">
            <img src="../../assets/image/menu/8.png" class="small" />
            <img src="../../assets/image/menu/88.png" class="big" />
            <div>评分评价</div>
          </div>
          <div class="nav-item" @click="go('deviceManagement')">
            <img src="../../assets/image/menu/3.png" class="small" />
            <img src="../../assets/image/menu/33.png" class="big" />
            <div>站点管理</div>
          </div>
          <div class="nav-item" @click="go('companyManagement')">
            <img src="../../assets/image/menu/5.png" class="small" />
            <img src="../../assets/image/menu/55.png" class="big" />
            <div>企业管理</div>
          </div>
          <div class="nav-item" @click="go('inforManagement')">
            <img src="../../assets/image/menu/6.png" class="small" />
            <img src="../../assets/image/menu/66.png" class="big" />
            <div>资料管理</div>
          </div>
          <div class="nav-item" @click="go('regionalSettings')">
            <img src="../../assets/image/menu/7.png" class="small" />
            <img src="../../assets/image/menu/77.png" class="big" />
            <div>系统设置</div>
          </div>
        </div>
        <div class="rightTwo">
          <div class="card">
            <div class="card-title">
              <span @click="go('warn')">异常告警</span>
              <el-radio-group
                v-model="abnormalType"
                size="mini"
                class="btn-group">
                <el-radio
                  :label="1"
                  border
                  @click.native.prevent="changeAbnormal(1)">站外还车</el-radio>
                <el-radio
                  :label="7"
                  border
                  @click.native.prevent="changeAbnormal(7)">非法车辆</el-radio>
                <el-radio
                  :label="13"
                  border
                  @click.native.prevent="changeAbnormal(13)">站外投车</el-radio>
                <el-radio
                  :label="14"
                  border
                  @click.native.prevent="changeAbnormal(14)">超区停放</el-radio>
                <el-radio
                  label="recycleSwitch"
                  border
                  @click.native.prevent="changeAbnormal('recycleSwitch')">回收站点</el-radio>
              </el-radio-group>
            </div>
            <warnTable
              :abnormalType="abnormalType"
              :selfAreaId="selfAreaId"
              :brandList="companyBrandList"
            ></warnTable>
          </div>
          <div class="card" style="height: calc(33vh - 30px);">
            <div class="card-title">
              <span class="nopoint">调度指引</span>
              <el-button
                v-if="aggregation === 0"
                @click="onShowDialog({ type: 3 })"
                plain
                size="small"
              >满桩值设置
              </el-button>
            </div>
            <dispatchGuide
              :selfAreaId="selfAreaId"
              :brandList="companyBrandList"
              @showModel="onShowDialog"
              @filterSite="filterSite"
            />
          </div>
          <div class="card">
            <div class="card-title">
              <span class="nopoint">待处理事件</span>
            </div>
            <div class="toDoList">
              <div class="item" @click="go('miBicycle', { site: true })">
                站点申请<span>{{
                  toDo && toDo.siteApplyPend ? toDo.siteApplyPend : 0
                }}</span>
              </div>
              <div class="item" @click="go('miBicycle', { role: 27 })">
                站点角色申请
                <span>{{
                    toDo && toDo.maintainPend ? toDo.maintainPend : 0
                  }}</span>
              </div>
              <div
                class="item"
                @click="go('deviceManagement', { equipmentPower: '0-10' })"
              >
                站点电量低于10%<span>{{
                  toDo && toDo.siteLowPowerPend ? toDo.siteLowPowerPend : 0
                }}</span>
              </div>
              <div class="item" @click="go('miBicycle', { role: 5 })">
                违规举报
                <span>{{ toDo && toDo.accusePend ? toDo.accusePend : 0 }}</span>
              </div>
              <div
                class="item"
                @click="go('regionalSettings', { audit: true })"
              >
                平台账号申请<span>{{
                  toDo && toDo.userPend ? toDo.userPend : 0
                }}</span>
              </div>
              <div class="item" @click="go('miBicycle', { role: 31 })">
                运维员申请
                <span>{{
                    toDo && toDo.dispatchPend ? toDo.dispatchPend : 0
                  }}</span>
              </div>
              <div class="item" @click="go('miBicycle', { role: 32 })">
                监管员申请
                <span>{{
                    toDo && toDo.supervisePend ? toDo.supervisePend : 0
                  }}</span>
              </div>
              <div class="item" @click="go('miBicycle', { role: 34,clockWarn: true, dateFormat: clockDay,clockRole: 1})">
                运维员预警
                <span>{{ toDo && toDo.dispatchWarnPend ? toDo.dispatchWarnPend : 0 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 左侧菜单 -->
      <div class="aside-left">
        <div class="container">
          <SideBar dark />
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <w-dialog
      className="i-dialog"
      ref="w-dialog"
      :width="width"
      :title="dialogTitle"
      :isShowFooter="isShowFooter"
      @handleClose="handleClose"
      @handleCloseRight="handleClose"
      @onSure="onSure"
    >
      <template v-slot:content>
        <!-- 用户信息 -->
        <div v-if="type === '1'">
          <text-list-slot>
            <ul>
              <li>
                <span>登录账号：</span>
                <span>{{ user.username }}</span>
              </li>
              <li>
                <span>姓名：</span>
                <span>{{ user.name }}</span>
              </li>
              <li>
                <span>联系电话：</span>
                <span>{{ user.phone }}</span>
              </li>
              <li>
                <span>工作单位：</span>
                <span>{{ user.company }}</span>
              </li>
            </ul>
            <ul>
              <li>
                <span>角色类型：</span>
                <span>{{
                    user.roles && user.roles[0] && user.roles[0].roleName
                  }}</span>
              </li>
              <li>
                <span>权限区域：</span>
                <span>{{ user.areaName || "全国" }}</span>
              </li>
              <li>
                <span>使用时效：</span>
                <span
                >{{ user.createTime | dateFormat("yyyy-MM-dd") }}至{{
                    user.unavailableTime | dateFormat("yyyy-MM-dd")
                  }}</span
                >
              </li>
              <li class="mt10">
                <span style="vertical-align: top">身份证照：</span>
                <span>
                  <el-image
                    style="width: 100px; height: 100px; margin-right: 10px"
                    :src="user.idcardUrl | filterImage"
                    :preview-src-list="[
                      filterImage(user.idcardUrl),
                      filterImage(user.idcardBackUrl),
                    ]"
                  >
                  </el-image>
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="user.idcardBackUrl | filterImage"
                    :preview-src-list="[
                      filterImage(user.idcardBackUrl),
                      filterImage(user.idcardUrl),
                    ]"
                  >
                  </el-image>
                </span>
              </li>
            </ul>
            <ul>
              <li>
                <span>创建人：</span>
                <span>{{ user.name }}</span>
              </li>
              <li>
                <span>角色类型：</span>
                <span>{{
                    user && user.roles && user.roles[0] && user.roles[0].roleName
                  }}</span>
              </li>
              <li>
                <span>创建时间：</span>
                <span>{{ user.createTime | dateFormat("yyyy-MM-dd") }}</span>
              </li>
            </ul>
          </text-list-slot>
        </div>
        <!-- 修改密码 -->
        <div v-if="type === '2'">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="旧密码：" prop="oldPass" style="width: 50%">
              <el-input
                type="password"
                v-model="ruleForm.oldPass"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="新密码：" prop="newPass" style="width: 50%">
              <el-input
                type="password"
                v-model="ruleForm.newPass"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="type === '4'">
          <total-sum-chart
            v-show="checkUserAuth(64, 134)"
            :isAggregation="isAggregation"
            :selfAreaId="selfAreaId"
            :realHeight="500"
            initTimeType='月'
            initDataType="1"
            dark
            :key="componentKey"
          >
          </total-sum-chart>
        </div>
      </template>
    </w-dialog>
  </dv-full-screen-container>
</template>

<script>
import { mapGetters } from 'vuex'
import mapbox from './components/mapbox.vue'
import TotalRing from './components/TotalRingChart.vue'
import statistics from './components/statistics.vue'
import warnTable from './components/warnTable.vue'
import dispatchGuide from './components/dispatchGuide.vue'
import SideBar from '@/views/Layout/sidebar2'
import Api from '@/api'
import WDialog from '@/components/Model/index.vue'
import { filterImage } from '@/utils/tools'
import TextListSlot from '@/components/Listbox/textListSlot.vue'
import totalSumChart from '@/views/Operation/components/totalSumChart'
import Utils from '@/assets/js/util'
import singleTotalRing from './components/singleTotalRingChart'
import siteRanking from './components/siteRanking'
export default {
  name: 'index',
  components: {
    mapbox,
    TotalRing,
    SideBar,
    warnTable,
    statistics,
    dispatchGuide,
    WDialog,
    TextListSlot,
    totalSumChart,
    singleTotalRing,
    siteRanking
  },
  data() {
    return {
      width: '30%',
      num: 0,
      type: '',
      dialogTitle: '',
      ispie: true,
      areaId: '',
      ruleForm: {
        oldPass: '',
        newPass: ''
      },
      rules: {
        oldPass: [{ validator: this.validateOldPass, trigger: 'blur' }],
        newPass: [{ validator: this.validateNewPass, trigger: 'blur' }]
      },
      Loading: true,
      nTime: new Date(),
      nTimeTimer: null,
      Circle1: null,
      abnormalType: 0,
      statistical: {},
      siteMessage: [],
      toDo: {},
      isShowFooter: true,
      mapsite: [],
      companyBrandList: [],
      heightControl: 'calc(35vh - 20px)',
      heightControlTwo: 'calc(30vh - 25px)',
      siteType: '日',
      actionOrder: 0, // 0-租车，1-还车
      siteRankAllTime: new Date(),
      scale: {
        width: '1',
        height: '1'
      },
      scaleTime: null, // 定时任务
      baseWidth: 1920, // 设计稿尺寸
      baseHeight: 1080, // 设计稿尺寸
      baseProportion: 0, // 比例
      componentKey: 0,
      clockDay: this.dayjs().subtract(1, 'day').format('YYYY-MM-DD') // 考勤日统计-日期
    }
  },
  computed: {
    ...mapGetters([
      'userSelectAddressData',
      'user',
      'permissions',
      'userLevel',
      'currpath',
      'fullPileNum',
      'fullPileName'
    ]),
    selfAreaId() {
      if (this.userLevel < 2) {
        return ''
      } else {
        return this.$store.getters.selfAreaId
      }
    },
    isAggregation() {
      // 是否是非复合区下的实体区
      return (
        (this.aggregation == 0 && this.aggregationId == '') ||
        (this.aggregation == 1 && this.aggregationId)
      )
    },
    aggregationId() {
      // 实体区的复合区Id
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregationId
        : undefined
    },
    aggregation() {
      // 0 - 实体区
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregation
        : undefined
    }
  },
  created() {
    this.baseProportion = parseFloat((this.baseWidth/this.baseHeight).toFixed(2))
    this.init()
    this.getAreaBrandDetails()
  },
  watch: {
    selfAreaId() {
      this.abnormalType = 0 // 重置状态
      this.init()
      this.getAreaBrandDetails()
    }
  },
  mounted() {
    // -----------
    this.$nextTick(() => {
      this.calcRate()
      window.addEventListener('resize', this.resize);
      this.pollingNtime()
    })
  },
  methods: {
    sumchart() {
      this.type = '4'
      this.width = '60%'
      this.dialogTitle = '总量曲线图'
      this.isShowFooter = false
      // 每次打开子组件弹框时，componentKey的值都会自增1，可以确保每次创建新子组件实例
      this.componentKey += 1
      this.$refs['w-dialog'].onShowDialog()
    },
    filterImage(url) {
      return filterImage(url)
    },
    init() {
      this.getArea()
    },
    async getArea() {
      // 判断复合区有没有企业 如果没有企业 就获取上级的id
      if (!this.selfAreaId) {
        this.areaId = this.selfAreaId
        this.toDo = {}
      }
      const vm = this
      const hasLength = await vm.getEnterpriseListAndHasLength()
      if (!this.selfAreaId) {
        this.Loading = false
        return
      }
      if (!hasLength && vm.aggregation === 0) {
        vm.areaId = vm.aggregationId
      } else {
        vm.areaId = vm.selfAreaId
      }
      Api.getPendEvent({
        areaId: this.areaId,
        selfAreaId: this.selfAreaId
      }).then((res) => {
        this.Loading = false
        this.toDo = res.data
      })
    },
    async getEnterpriseListAndHasLength() {
      try {
        return new Promise((resolve) => {
          Api.getEnterpriseList({ selfAreaId: this.selfAreaId })
            .then((res) => {
              if (res.code === 200 && res.data && res.data.total) {
                resolve(true)
              } else {
                resolve(false)
              }
            })
            .catch((err) => {
              resolve(false)
              console.log('the getEnterpriseList has probleam: ', err)
            })
        })
      } catch (e) {
        console.log('the getEnterpriseList has probleam: ', e)
      }
    },
    pollingNtime() {
      this.nTime = new Date()
      this.nTimeTimer = setTimeout(() => {
        this.num++
        if (this.num > 180) {
          // 120秒重新获取待处理事件
          this.num = 0
          this.init()
        }
        this.nTime = new Date()
        this.pollingNtime()
      }, 1000)
    },
    changeAbnormal(val) {
      console.log(val, this.abnormalType)
      Utils.$emit('cleanPolygon', 'msg')
      if (this.abnormalType === val) {
        // eslint-disable-next-line no-useless-return
        return
      } else {
        if (val === 'bikeMonitor') {
          this.onShowDialog({
            type: 5,
            selfAreaId: this.selfAreaId
          })
        } else {
          this.abnormalType = val
          this.$refs.mapbox && this.$refs.mapbox.getDashboardBike(val)
        }
      }
    },
    notupload() {
      this.onShowDialog({
        type: 7,
        selfAreaId: this.selfAreaId
      })
    },
    go(path, query) {
      if (path == 'http://ydkh.gxdcjg.com') {
        window.open(path)
        return
      }
      if (this.selfAreaId) {
        this.$router.push({
          name: path,
          params: { id: this.selfAreaId, ...query }
        })
      } else {
        this.$router.push({ name: path, params: { ...query } })
      }
    },
    refresh() {
      this.abnormalType = 0
      this.$nextTick(() => {
        this.$refs.mapbox && this.$refs.mapbox.refreshSite()
      })
    },
    filterBike(params) {
      if (!params) {
        // this.$refs.mapbox && this.$refs.mapbox.refreshSite();
      } else {
        params = {
          ...{
            selfAreaId: this.selfAreaId,
            currentPage: 1,
            pageSize: 5000
          },
          ...params
        }
        Api.getBrandOnlineBike(params).then((res) => {
          if (res.code === 200) {
            this.$refs.mapbox.filterBike(res.data.lists)
          } else {
            this.$message.warning(res.message)
          }
        })
      }
    },
    onShowDialog(data) {
      if (data.type == 3) {
        if (this.selfAreaId) {
          this.$router.push({
            name: 'dailyDuty',
            params: { id: this.selfAreaId },
            query: { type: 3 }
          })
        } else {
          this.$router.push({ name: 'dailyDuty', query: { type: 3 } })
        }
      } else {
        this.$refs.mapbox.onShowDialog(data)
      }
    },
    filterSite(status) {
      this.$refs.mapbox.filterSite(status)
    },
    handleCommand(command) {
      this.type = command
      this.width = '30%'
      switch (command) {
        case '1':
          this.showUserInfo()
          break
        case '2':
          this.handleEditPassword()
          break
        case '3':
          this.onLogout()
          break
      }
    },
    showUserInfo() {
      this.dialogTitle = '用户信息'
      this.isShowFooter = false
      this.$refs['w-dialog'].onShowDialog()
    },
    handleEditPassword() {
      this.dialogTitle = '修改密码'
      this.isShowFooter = true
      this.$refs['w-dialog'].onShowDialog()
    },
    onLogout() {
      this.$confirm('你是否确定退出登录？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          Api.logout().then((res) => {
            if (res.code === 200) {
              this.$store.dispatch('user/logout').then(() => {
                this.$router.push('/login')
              })
            } else {
              this.$message.warning(res.message)
            }
          })
        })
        .catch(() => {})
    },
    handleClose() {
      this.dialogTitle = ''
      this.isShowFooter = true
      this.$refs['w-dialog'].onCloseDialog()
    },
    onSure() {
      const vm = this
      vm.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const params = {
            selfAreaId: vm.selfAreaId
          }
          const data = {
            oldPwd: vm.ruleForm.oldPass,
            newPwd: vm.ruleForm.newPass
          }
          Api.pwd(data, params).then((res) => {
            if (res.code === 200) {
              vm.$message.success('密码修改成功！')
              vm.handleClose()
            } else {
              vm.$message.warning(res.message)
            }
          })
        } else {
          return false
        }
      })
    },
    // 统计图汇总区域企业品牌信息
    getAreaBrandDetails() {
      this.companyBrandList = []
      const params = {
        selfAreaId: this.selfAreaId
      }
      Api.areaBrandDetails(params).then((res) => {
        if (res.code === 200) {
          res.data.forEach(item => {
            if (item.brandName) {
              this.companyBrandList.push(item)
            }
          })
          console.log(this.companyBrandList, '企业品牌数')
        }
      })
    },
    // 计算放大倍数
    calcRate() {
      const contentRef = this.$refs.contentRef
      if (!contentRef || !contentRef.style) return
      // 当前宽高比
      const currentRate = parseFloat((window.innerWidth / window.innerHeight).toFixed(2));
      if (currentRate > this.baseProportion) {
        // 表示更宽
        this.scale.width = ((window.innerHeight * this.baseProportion) / this.baseWidth).toFixed(2);
        this.scale.height = (window.innerHeight / this.baseHeight).toFixed(2);
        contentRef.style.transform = `scale(${this.scale.width}, ${this.scale.height}) translate(-50%, -50%)`;
      } else {
        // 表示更高
        this.scale.height = ((window.innerWidth / this.baseProportion) / this.baseHeight).toFixed(2);
        this.scale.width = (window.innerWidth / this.baseWidth).toFixed(2);
        contentRef.style.transform = `scale(${this.scale.width}, ${this.scale.height}) translate(-50%, -50%)`;
      }
    },
    // 屏幕大小改变更新倍数
    resize () {
      clearTimeout(this.scaleTime)
      this.scaleTime = setTimeout(() => {
        this.calcRate()
      }, 0)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    if (this.nTimeTimer) {
      clearTimeout(this.nTimeTimer)
      this.nTimeTimer = null
    }
  }
}
</script>

<style lang='less'>
.box-content{
  width: 1920px;
  height: 1080px;
  position: absolute;
  transform: translate(-50%, -50%);
  transform-origin: left top;
}
.box-content,
.i-dialog {
  /*修改滚动条样式*/
  div::-webkit-scrollbar {
    width: 6px;
    height: 10px;
    /**/
  }
  div::-webkit-scrollbar-track {
    background: #0c3444;
    border-radius: 2px;
  }
  div::-webkit-scrollbar-thumb {
    background: #00dada;
    border-radius: 10px;
  }
  div::-webkit-scrollbar-thumb:hover {
    background: #00dada;
  }
  div::-webkit-scrollbar-corner {
    background: #179a16;
  }
}
</style>
<style scoped lang="less">
* {
  box-sizing: border-box;
}

.p16 {
  padding: 16px;
}

.el-dropdown-menu {
  background: #06101d;
  box-shadow: 0px 0px 8px 0px rgba(0, 218, 218, 0.3);
  border-radius: 4px;
  border: 1px solid #3e7878;
  .el-dropdown-menu__item {
    color: rgba(0, 218, 218, 0.65);
  }
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: #052430;
  color: #00dada;
}
.app-container {
  background-color: #06101d;
  height: 100vh;
  .n-header {
    height: 80px;
    width: 100%;
    background-repeat: no-repeat;
    background-size: 100% 80px;
    // min-width: 1920px;
    background-image: url("//media.winbaoxian.com/autoUpload/activity/__3f9a5e2c53f1575.png");
    .n-name {
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #00dada;
      text-align: center;
      padding-top: 17px;
      line-height: 1;
    }
    .n-time {
      font-size: 16px;
      font-family: DINAlternate-Bold, DINAlternate;
      font-weight: bold;
      color: #00dada;
      line-height: 1;
      padding-left: 36px;
    }
    .el-dropdown {
      float: right;
      margin-right: 50px;
      .el-dropdown-link {
        i {
          color: #00dada;
        }
      }
    }
  }
    .n-body {
    box-sizing: border-box;
    padding: 2px 16px;
    display: grid;
    gap: 10px;
    height: calc(100vh - 80px);
    grid-template-areas:
      "total map right"
      "total map right"
      "yunying map right"
      "yunying map right"
      "yunying nav right";
    grid-template-rows: repeat(5, 1fr);
    grid-template-columns: 1fr 2fr 1fr;
    > div {
      &:nth-child(1) {
        grid-area: total;
      }
      &:nth-child(2) {
        grid-area: map;
        grid-row-start: span 4;
      }
      &:nth-child(3) {
        grid-area: yunying;
        grid-row-start: span 3;
      }
      &:nth-child(4) {
        grid-area: nav;
      }
      &:nth-child(5) {
        grid-area: right;
      }
    }
    .right {
      display: flex;
      gap: 10px;
      flex-direction: column;
      background-color: #06101d;
      > div {
        flex-grow: 1;
        &:nth-child(1) {
          height: 280px;
        }
        &:nth-child(2) {
          height: 400px;
        }
        &:nth-child(3) {
          height: 222px;
        }
      }
    }
    .card {
      position: relative;
      display: flex;
      flex-direction: column;
      background: hsla(180, 100%, 43%, 0.1);
      border: solid 1px #3e7878;

      &::before,
      &::after {
        content: "";
        width: 15px;
        height: 15px;
        position: absolute;
        bottom: 0;
      }
      &::before {
        background: url("~@/assets/image/左下角.png");
        background-size: cover;
        left: 0;
      }
      &::after {
        background: url("~@/assets/image/右下角.png");
        background-size: cover;
        right: -1px;
        bottom: -1px;
      }
      .card-title {
        position: relative;
        flex-shrink: 0;
        height: 50px;
        padding: 16px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 16px;
        background: url("~@/assets/image/标题栏.png") no-repeat bottom;
        background-size:27.1875rem auto;
        .el-button {
          float: right;
          border: 1px solid #00dada;
          color: #00dada;
          line-height: 22px;
          font-size: 12px;
          text-align: center;
          padding: 0 12px;
          background: #052430;
          margin-top: -6px;
          margin-left: 10px;
        }
        > span {
          cursor: pointer;
          &.nopoint {
            cursor: default;
          }
        }
        .btn-group {
          float: right;
          margin-top: -6px;
          > div {
            display: inline-block;
            width: 20px;
            height: 20px;
            border-radius: 4px;
            border: 1px solid #00dada;
            color: #00dada;
            line-height: 20px;
            font-size: 12px;
            text-align: center;
            margin-left: 10px;
            cursor: pointer;
            &.no_active {
              border-color: #3e7878;
              color: #00dada;
            }
          }
          .el-radio--mini {
            height: 24px;
            border: 1px solid #3e7878;
            line-height: 22px;
            padding: 0 6px;
            background: transparent;
            margin-right: 0;
            color: #00dada !important;
            /deep/ .el-radio__input {
              display: none;
            }
            /deep/ .el-radio__label {
              padding: 0;
              color: #00dada;
            }
            &:hover,
            &.is-checked {
              box-shadow: 0px 0px 8px 0px #00dada inset;
            }
          }
        }
        &::before,
        &::after {
          content: "";
          width: 15px;
          height: 15px;
          position: absolute;
          top: 0;
        }
        &::before {
          background-image: url("~@/assets/image/左上角.png");
          left: -1px;
          top: -1px;
          background-size: cover;
        }
        &::after {
          background-image: url("~@/assets/image/右上角.png");
          right: -1px;
          top: -1px;
        }
        span {
          position: relative;
          &::after {
            position: absolute;
            bottom: -7px;
            left: 0;
            content: "";
            height: 3px;
            width: 100%;
            background: #00dada;
          }
        }
      }
    }
    .nav {
      display: flex;
      justify-content: space-around;
      padding: 20px 12px 45px;
      position: relative;
      .top-img {
        position: absolute;
        top: 0;
      }
      .footer-img {
        position: absolute;
        bottom: 0;
        width: 920px;
      }
      .big {
        display: none;
      }
      &-item {
        width: calc(100% / 7);
        text-align: center;
        cursor: pointer;
        &:hover,
        &.active {
          .big {
            display: inline-block;
            overflow: hidden;
            margin-top: 6px;
            border-radius: 50%;
            & + div {
              margin-top: 6px;
              font-weight: 500;
              color: #00dada;
              font-size: 16px;
              margin-bottom: 6px;
            }
          }
          .small {
            display: none;
          }
        }
        &.active {
          background: url("~@/assets/image/select.png") no-repeat center;
        }
        > img {
          margin-top: 18px;
        }
        div {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(255, 255, 255, 0.65);
          margin-top: 15px;
          margin-bottom: 7px;
        }
      }
    }
  }
  .totalTwo {
    grid-area: totalTwo;
  }
  .mapTwo {
    grid-area: mapTwo;
    grid-row-start: span 5;
  }
  .yunyingTwo {
    grid-area: yunyingTwo;
  }
  .navTwo {
    grid-area: navTwo;
  }
  .rightTwo {
    grid-area: rightTwo;
  }
  .menuTwo{
    grid-area: menuTwo;
    //  grid-row-start: span 4;
  }
  .n_body_two {
    box-sizing: border-box;
    padding: 2px 16px;
    display: grid;
    gap: 10px;
    height: calc(100vh - 80px);
    grid-template-areas:
      "totalTwo mapTwo rightTwo"
      "totalTwo mapTwo rightTwo"
      "yunyingTwo mapTwo rightTwo"
      "yunyingTwo mapTwo rightTwo"
      "menuTwo mapTwo rightTwo"
      "menuTwo navTwo rightTwo"
      "menuTwo navTwo rightTwo";
    grid-template-rows: repeat(5, 1fr);
    grid-template-columns: 1fr 2fr 1fr;
    .rightTwo {
      display: flex;
      gap: 10px;
      flex-direction: column;
      background-color: #06101d;
      > div {
        flex-grow: 1;
        &:nth-child(1) {
          height: 280px;
        }
        &:nth-child(2) {
          height: 400px;
        }
        &:nth-child(3) {
          height: 222px;
        }
      }
    }
    .card {
      position: relative;
      display: flex;
      flex-direction: column;
      background: hsla(180, 100%, 43%, 0.1);
      border: solid 1px #3e7878;

      &::before,
      &::after {
        content: "";
        width: 15px;
        height: 15px;
        position: absolute;
        bottom: 0;
      }
      &::before {
        background: url("~@/assets/image/左下角.png");
        background-size: cover;
        left: 0;
      }
      &::after {
        background: url("~@/assets/image/右下角.png");
        background-size: cover;
        right: -1px;
        bottom: -1px;
      }
      .card-title {
        position: relative;
        flex-shrink: 0;
        height: 50px;
        padding: 16px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 16px;
        background: url("~@/assets/image/标题栏.png") no-repeat bottom;
        background-size:27.1875rem auto;
        .el-button {
          float: right;
          border: 1px solid #00dada;
          color: #00dada;
          line-height: 22px;
          font-size: 12px;
          text-align: center;
          padding: 0 12px;
          background: #052430;
          margin-top: -6px;
          margin-left: 10px;
        }
        > span {
          cursor: pointer;
          &.nopoint {
            cursor: default;
          }
        }
        .btn-group {
          float: right;
          margin-top: -6px;
          > div {
            display: inline-block;
            width: 20px;
            height: 20px;
            border-radius: 4px;
            border: 1px solid #00dada;
            color: #00dada;
            line-height: 20px;
            font-size: 12px;
            text-align: center;
            margin-left: 10px;
            cursor: pointer;
            &.no_active {
              border-color: #3e7878;
              color: #00dada;
            }
          }
          .el-radio--mini {
            height: 24px;
            border: 1px solid #3e7878;
            line-height: 22px;
            padding: 0 6px;
            background: transparent;
            margin-right: 0;
            color: #00dada !important;
            /deep/ .el-radio__input {
              display: none;
            }
            /deep/ .el-radio__label {
              padding: 0;
              color: #00dada;
            }
            &:hover,
            &.is-checked {
              box-shadow: 0px 0px 8px 0px #00dada inset;
            }
          }
        }
        &::before,
        &::after {
          content: "";
          width: 15px;
          height: 15px;
          position: absolute;
          top: 0;
        }
        &::before {
          background-image: url("~@/assets/image/左上角.png");
          left: -1px;
          top: -1px;
          background-size: cover;
        }
        &::after {
          background-image: url("~@/assets/image/右上角.png");
          right: -1px;
          top: -1px;
        }
        span {
          position: relative;
          &::after {
            position: absolute;
            bottom: -7px;
            left: 0;
            content: "";
            height: 3px;
            width: 100%;
            background: #00dada;
          }
        }
      }
    }
    .navTwo {
      display: flex;
      justify-content: space-around;
      padding: 20px 12px 45px;
      position: relative;
      .top-img {
        position: absolute;
        top: 0;
      }
      .footer-img {
        position: absolute;
        bottom: 0;
        width: 920px;
      }
      .big {
        display: none;
      }
      .nav-item {
        width: calc(100% / 7);
        text-align: center;
        cursor: pointer;
        &:hover,
        &.active {
          .big {
            display: inline-block;
            overflow: hidden;
            margin-top: 6px;
            border-radius: 50%;
            & + div {
              margin-top: 6px;
              font-weight: 500;
              color: #00dada;
              font-size: 16px;
              margin-bottom: 6px;
            }
          }
          .small {
            display: none;
          }
        }
        &.active {
          background: url("~@/assets/image/select.png") no-repeat center;
        }
        > img {
          margin-top: 18px;
        }
        div {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(255, 255, 255, 0.65);
          margin-top: 15px;
          margin-bottom: 7px;
        }
      }
    }
  }
  .aside-left {
    width: 210px;
    height: 100vh;
    background: #06101d;
    position: fixed;
    left: 0;
    top: 0;
    transform: translateX(-100%);
    transition: all 0.3s;
    z-index: 1;
    .container {
      height: 100vh;
      overflow: auto;
    }
    &:hover {
      transform: translateX(0);
    }
    &::after {
      content: "";
      background: url("~@/assets/image/按钮.png") no-repeat center;
      background-size: contain;
      width: 20px;
      height: 211px;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(100%, -50%);
    }
  }

  .toDoList {
    display: flex;
    flex-wrap: wrap;
    padding: 16px;
    justify-content: space-between;
    height: 100%;
    overflow: auto;
    align-content: center;
    .item {
      margin-top: 5px;
      line-height: 35px;
      color: rgba(255, 255, 255, 0.65);
      font-size: 12px;
      flex: 0 0 50%;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      cursor: pointer;
      &:nth-child(2n-1) {
        padding-right: 23px;
      }
      &:nth-child(2n) {
        padding-left: 23px;
      }
      > span {
        float: right;
        width: 60px;
        height: 20px;
        background: #00dada;
        border-radius: 10px;
        color: #000;
        font-family: PingFangSC-Regular, PingFang SC;
        text-align: center;
        font-size: 14px;
        line-height: 20px;
        margin-top: 7px;
      }
    }
  }
}

/deep/ .el-table,
.el-table__expanded-cell {
  background-color: initial;
}
/deep/ .el-table::before {
  background-color: initial;
}
.glow-button {
  transition: box-shadow 0.3s ease;
}

.glow-button:hover {
  box-shadow: inset 0 0 8px rgba(17, 191, 199, 0.6), inset 0 0 16px rgba(45, 130, 2, 0.4);
}


</style>
